// mirrors your GeneralTaskIndex.tsx pattern
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DriverList from './DriverList';
import DriverForm, { FormMode } from './DriverForm';
import DriverDashboard from './DriverDashboard';

// TODO: replace with real role checks from your auth store
const hasDriverModuleAccess = true;        // view
const canCreateOrEditDriver = true;        // create/edit

const DriverFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: FormMode = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';
  else mode = 'view';

  if (mode !== 'view' && !canCreateOrEditDriver) return <Navigate to="/unauthorized" />;

  return <DriverForm mode={mode} />;
};

const DriverModule: React.FC = () => {
  if (!hasDriverModuleAccess) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<DriverDashboard />} />
      <Route path="dashboard" element={<DriverDashboard />} />
      <Route path="list" element={<DriverList />} />
      <Route path="create" element={<DriverFormWrapper />} />
      <Route path=":id" element={<DriverFormWrapper />} />
      <Route path=":id/edit" element={<DriverFormWrapper />} />
    </Routes>
  );
};

export default DriverModule;